import {Observable, of} from 'rxjs'
import {Injectable} from '@angular/core'
import {LoggerService} from '../service/logger.service'
import {ProgressService} from '../service/progress.service'
import {v4 as generateUuid} from 'uuid'
import {tap} from 'rxjs/internal/operators/tap'
import {Form} from '../model/form'
import {ConfigService} from '../service/config.service'

@Injectable()
export class HttpService {

  constructor(private config: ConfigService,
              private logger: LoggerService,
              private formStateSvc: ProgressService,) {
  }

  get(url: string, params?: any): Observable<Form> {
    const id = url.split('/').pop()
    return of({id, sections: []} as Form)
  }

  post(url: string, body?: any): Observable<any> {
    this.formStateSvc.start()
    console.info(`POST ${url} `, body)
    return of(body).pipe(
      tap(() => this.formStateSvc.saved()),
    )
  }

  put(url: string, body?: any): Observable<any> {
    this.formStateSvc.start()
    console.info(`PUT ${url} `, body)
    return of({...body, id: generateUuid()}).pipe(
      tap(() => this.formStateSvc.saved()),
    )
  }

  delete(url: string): Observable<any> {
    this.formStateSvc.start()
    console.info(`DELETE ${url} `)
    return of().pipe(
      tap(() => this.formStateSvc.saved()),
    )
  }
}
